import { Directive, OnInit, ElementRef, inject } from '@angular/core';

import mediumZoom from 'medium-zoom';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[mediumZoom]',
  standalone: true,
   
  host: {
    class: 'cursor-pointer',
  },
})
export class MediumZoomDirective implements OnInit {
  private elementRef = inject(ElementRef);
  /* constructor(private elementRef: ElementRef) {} */

  ngOnInit() {
    // console.log(this.elementRef.nativeElement);
    mediumZoom(this.elementRef.nativeElement, {
      scrollOffset: 0,
      margin: 24,
      background: 'rgba(25, 18, 25, .7)',
    });
  }
}
